(function () {
  if (window.snagSaleInit) return;
  window.snagSaleInit = true;

  var phaseApi = window.snagHwPhase;
  var store = {
    get: function (k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { if (v) window.sessionStorage.setItem(k, v); else window.sessionStorage.removeItem(k); } catch (e) {} }
  };
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  function initCountdown(el) {
    var nums = el.querySelectorAll('[data-cd-num]');
    var names = el.querySelectorAll('[data-cd-name]');
    var longLabels = (el.getAttribute('data-labels-long') || '').split('|');
    var shortLabels = (el.getAttribute('data-labels-short') || '').split('|');
    var timer = null;
    var lastText = '';

    function target() {
      if (!phaseApi) return 0;
      var phase = phaseApi.get(Date.now());
      if (phase === '1') return phaseApi.p1;
      if (phase === '2') return phaseApi.p2;
      return 0;
    }

    function render() {
      var end = target();
      var left = end - Date.now();
      if (!end || left < 1000) {
        el.hidden = true;
        if (phaseApi) phaseApi.set();
        var next = target();
        if (next && next - Date.now() >= 1000) {
          el.hidden = false;
          schedule();
        }
        return;
      }
      el.hidden = false;
      var secs = Math.floor(left / 1000);
      var d = Math.floor(secs / 86400), h = Math.floor((secs % 86400) / 3600), m = Math.floor((secs % 3600) / 60), s = secs % 60;
      var vals, labels;
      if (secs < 86400) {
        vals = [h, m, s];
        labels = shortLabels;
      } else {
        vals = [d, h, m];
        labels = longLabels;
      }
      var text = vals.join(':') + labels.join('');
      if (text !== lastText) {
        for (var i = 0; i < 3; i++) {
          if (nums[i]) nums[i].textContent = pad(vals[i]);
          if (names[i]) names[i].textContent = labels[i] || '';
        }
        lastText = text;
      }
      schedule();
    }

    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(render, 1000 - (Date.now() % 1000) + 5);
    }

    document.addEventListener('hw:phase', function () { lastText = ''; render(); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) render(); });
    render();
  }

  function initStickyStrip(slot) {
    if (!('IntersectionObserver' in window)) return;
    var mq = window.matchMedia('(max-width: 767px)');
    var strip = slot.querySelector('[data-sale-strip-sticky]');
    if (!strip) return;
    var visible = true;

    function update() {
      var phase = document.documentElement.getAttribute('data-hw-phase');
      var stick = mq.matches && !visible && phase === '1';
      if (stick && !slot.classList.contains('is-stuck')) {
        slot.style.minHeight = slot.offsetHeight + 'px';
        document.documentElement.style.setProperty('--hw-strip-h', strip.offsetHeight + 'px');
        slot.classList.add('is-stuck');
      } else if (!stick && slot.classList.contains('is-stuck')) {
        slot.classList.remove('is-stuck');
        slot.style.minHeight = '';
        document.documentElement.style.removeProperty('--hw-strip-h');
      }
    }

    new IntersectionObserver(function (entries) {
      var e = entries[0];
      visible = e.isIntersecting || e.boundingClientRect.top > 0;
      update();
    }, { threshold: 0 }).observe(slot);
    if (mq.addEventListener) mq.addEventListener('change', update);
    document.addEventListener('hw:phase', update);
  }

  function canon(value) {
    return String(value).replace(/\s*\(\s*\d[\d\s\-\u2013]*\)\s*$/, '').trim();
  }

  // Short F folds into E only while Search & Discovery still bundles it there, which the
  // size labels tell us ("E / Short F (16-18)"). Once Short F is its own group it gets its
  // own chip, and that chip also shows F-only styles (isShortF / fits / applyFilter).
  var SIZE_ALIAS = { 'H': 'G', 'I': 'G', 'J': 'G' };
  function isShortF(value) { return /^(short|kurz)\s*f$/i.test(canon(value)); }
  function group(value) {
    var c = canon(value);
    return SIZE_ALIAS[c.toUpperCase().replace(/\s+/g, ' ')] || c;
  }

  function sizeLetters(value) {
    var range = /\(\s*([A-J])\s*[-–]\s*([A-J])\s*\)/i.exec(value);
    if (range) {
      var a = range[1].toUpperCase().charCodeAt(0), b = range[2].toUpperCase().charCodeAt(0), out = [];
      for (var c = a; c <= b; c++) out.push(String.fromCharCode(c));
      return { range: true, letters: out };
    }
    return { range: false, letters: (canon(value).match(/\b[A-J]\b/g) || []) };
  }

  function initToolbar(bar) {
    try {
      var bundled = JSON.parse(bar.getAttribute('data-size-labels') || '[]').some(function (pair) {
        return /^E\s*\/\s*(short|kurz)\s*F/i.test(String(pair[1] || ''));
      });
      if (bundled) { SIZE_ALIAS['SHORT F'] = 'E'; SIZE_ALIAS['KURZ F'] = 'E'; }
    } catch (err) {}
    var grids = [].slice.call(document.querySelectorAll('[data-sale-grid][data-filterable]'));
    if (!grids.length) return;
    var chipsWrap = bar.querySelector('[data-size-chips]');
    var select = bar.querySelector('[data-sale-sort]');
    var status = bar.querySelector('[data-sale-status]');
    var cards = [];

    grids.forEach(function (grid) {
      [].slice.call(grid.querySelectorAll('[data-sale-card]')).forEach(function (card, i) {
        var sizes = [];
        try { sizes = JSON.parse(card.getAttribute('data-sizes') || '[]').map(group); } catch (err) {}
        var vmap = {};
        try { var raw = JSON.parse(card.getAttribute('data-variants') || '{}'); Object.keys(raw).forEach(function (k) { var g = group(k); if (!vmap[g] || g === canon(k)) vmap[g] = raw[k]; }); } catch (err) {}
        cards.push({
          el: card,
          grid: grid,
          order: i,
          oneSize: card.getAttribute('data-one-size') === 'true',
          saving: parseInt(card.getAttribute('data-saving'), 10) || 0,
          price: parseInt(card.getAttribute('data-price'), 10) || 0,
          pid: card.getAttribute('data-pid'),
          sizes: sizes,
          vmap: vmap,
          links: [].slice.call(card.querySelectorAll('a[href*="/products/"]')).map(function (a) { return { a: a, base: a.getAttribute('href').split('?')[0] }; })
        });
      });
    });

    var seen = {}, chipValues = [];
    cards.forEach(function (c) {
      c.sizes.forEach(function (v) {
        if (seen[v]) return;
        seen[v] = true;
        if (!sizeLetters(v).range) chipValues.push(v);
      });
    });
    if (!chipValues.length) chipValues = Object.keys(seen);
    var allLettered = chipValues.every(function (v) { return sizeLetters(v).letters.length; });
    if (allLettered) {
      chipValues.sort(function (a, b) {
        var ka = sizeLetters(a).letters[0].charCodeAt(0) * 2 + (isShortF(a) ? 0 : 1);
        var kb = sizeLetters(b).letters[0].charCodeAt(0) * 2 + (isShortF(b) ? 0 : 1);
        return ka - kb;
      });
    }
    var sizeLabels = {};
    try {
      JSON.parse(bar.getAttribute('data-size-labels') || '[]').forEach(function (pair) {
        var key = group(pair[0]), label = String(pair[1] || '');
        if (key !== canon(pair[0])) return;
        if (!sizeLabels[key] || (label.indexOf('(') !== -1 && sizeLabels[key].indexOf('(') === -1)) sizeLabels[key] = label;
      });
    } catch (err) {}
    function labelFor(v) {
      return sizeLabels[v] && sizeLabels[v].indexOf('(') !== -1 ? sizeLabels[v] : v;
    }
    var savedSize = store.get('snagSaleSize');
    if (savedSize) savedSize = group(savedSize);
    if (savedSize && chipValues.indexOf(savedSize) === -1 && !seen[savedSize]) chipValues.push(savedSize);
    chipValues.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'snag-sale-chip';
      b.setAttribute('aria-pressed', 'false');
      b.setAttribute('data-size', v);
      b.textContent = labelFor(v);
      chipsWrap.appendChild(b);
    });

    var activeSize = '';

    function setSize(value) {
      activeSize = value;
      [].forEach.call(chipsWrap.querySelectorAll('[data-size]'), function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-size') === value ? 'true' : 'false');
      });
    }

    function fits(card) {
      if (!activeSize || card.oneSize) return true;
      if (card.sizes.indexOf(activeSize) !== -1) return true;
      if (isShortF(activeSize) && card.sizes.indexOf('F') !== -1) return true;
      var want = sizeLetters(activeSize).letters;
      return card.sizes.some(function (v) {
        var info = sizeLetters(v);
        return info.range && want.some(function (l) { return info.letters.indexOf(l) !== -1; });
      });
    }

    function applyFilter() {
      var shown = 0;
      cards.forEach(function (c) {
        var ok = fits(c);
        c.el.hidden = !ok;
        if (ok) shown++;
      });
      grids.forEach(function (grid) {
        var any = grid.querySelector('[data-sale-card]:not([hidden])');
        var empty = grid.parentNode.querySelector('[data-sale-empty]');
        if (empty) empty.hidden = !!any;
      });
      cards.forEach(function (c) {
        var vid = '';
        if (activeSize && !c.oneSize) {
          vid = c.vmap[activeSize] || (isShortF(activeSize) ? c.vmap['F'] : '') || '';
          if (!vid) {
            var want = sizeLetters(activeSize).letters;
            Object.keys(c.vmap).some(function (k) {
              var info = sizeLetters(k);
              if (info.range && want.some(function (l) { return info.letters.indexOf(l) !== -1; })) { vid = c.vmap[k]; return true; }
              return false;
            });
          }
        }
        c.links.forEach(function (l) { l.a.setAttribute('href', vid ? l.base + '?variant=' + vid : l.base); });
      });
      if (status) status.textContent = activeSize ? (status.getAttribute('data-label-in') || 'Showing [n] styles in [size]').replace('[n]', shown).replace('[size]', labelFor(activeSize)) : '';
    }

    chipsWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-size]');
      if (!btn) return;
      setSize(btn.getAttribute('data-size'));
      store.set('snagSaleSize', activeSize);
      applyFilter();
    });

    var ranks = null;
    var ranksPromise = null;

    function loadRanks() {
      if (ranksPromise) return ranksPromise;
      var ids = grids.map(function (g) { return g.getAttribute('data-section-id'); }).filter(Boolean).slice(0, 5);
      var url = (bar.getAttribute('data-sort-url') || window.location.pathname) + '?sort_by=best-selling&sections=' + encodeURIComponent(ids.join(','));
      var view = bar.getAttribute('data-view');
      if (view) url += '&view=' + encodeURIComponent(view);
      ranksPromise = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (json) {
          ranks = {};
          var parser = new DOMParser();
          Object.keys(json).forEach(function (id) {
            if (!json[id]) return;
            var doc = parser.parseFromString(json[id], 'text/html');
            [].forEach.call(doc.querySelectorAll('[data-sale-card]'), function (el) {
              ranks[el.getAttribute('data-pid')] = parseInt(el.getAttribute('data-rank'), 10) || 0;
            });
          });
          return ranks;
        })
        .catch(function () { ranksPromise = null; return null; });
      return ranksPromise;
    }

    function applySort(mode) {
      var cmp;
      if (mode === 'saving') cmp = function (a, b) { return (b.saving - a.saving) || (a.order - b.order); };
      else if (mode === 'price') cmp = function (a, b) { return (a.price - b.price) || (a.order - b.order); };
      else if (mode === 'best' && ranks) cmp = function (a, b) { return ((ranks[a.pid] || 1e9) - (ranks[b.pid] || 1e9)) || (a.order - b.order); };
      else cmp = function (a, b) { return a.order - b.order; };
      grids.forEach(function (grid) {
        cards.filter(function (c) { return c.grid === grid; }).sort(cmp).forEach(function (c) { grid.appendChild(c.el); });
      });
    }

    function chooseSort(mode) {
      if (mode === 'best' && !ranks) {
        bar.setAttribute('aria-busy', 'true');
        loadRanks().then(function () {
          bar.removeAttribute('aria-busy');
          if (select.value === 'best') applySort(ranks ? 'best' : 'stock');
        });
        return;
      }
      applySort(mode);
    }

    if (savedSize && chipsWrap.querySelector('[data-size="' + savedSize.replace(/"/g, '\\"') + '"]')) {
      setSize(savedSize);
      applyFilter();
    }
    var savedSort = store.get('snagSaleSort');
    if (savedSort && select.querySelector('option[value="' + savedSort + '"]')) {
      select.value = savedSort;
      if (savedSort !== 'stock') chooseSort(savedSort);
    }

    select.addEventListener('change', function () {
      store.set('snagSaleSort', select.value === 'stock' ? '' : select.value);
      chooseSort(select.value);
    });

  }

  function keepView() {
    var view = new URLSearchParams(window.location.search).get('view');
    if (!view) return;
    [].forEach.call(document.querySelectorAll('a[data-sale-tag-link], a.snag-sale-tier-chip'), function (a) {
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) !== '/') return;
      var url = new URL(href, window.location.origin);
      if (!url.searchParams.has('view')) url.searchParams.set('view', view);
      a.setAttribute('href', url.pathname + url.search + url.hash);
    });
  }

  function init() {
    keepView();
    [].forEach.call(document.querySelectorAll('[data-sale-countdown]'), initCountdown);
    [].forEach.call(document.querySelectorAll('.snag-sale-strip-slot--sticky'), initStickyStrip);
    [].forEach.call(document.querySelectorAll('[data-sale-toolbar]'), initToolbar);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
